<template>
  <Dialog
    v-model="visible"
    class="provider-consent-dialog"
    title="Provider Consent"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <p class="provider-consent-description">
      I understand that the tests have established reference ranges for adults (≥18 years of age)
      and that pediatric reference ranges have not been established for certain tests. I acknowledge
      that I may order the test, and I am responsible for interpreting results based on the clinical
      evaluation of a pediatric individual.
    </p>

    <div class="checkbox-group">
      <CheckBox
        :status="selection === 'yes' ? 'checked' : 'uncheck'"
        @changeStatus="(s) => onSelect('yes', s)"
      >
        Yes, I consent.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </CheckBox>
      <CheckBox
        :status="selection === 'no' ? 'checked' : 'uncheck'"
        @changeStatus="(s) => onSelect('no', s)"
      >
        NO, I do not consent.
      </CheckBox>
    </div>

    <div class="dob-dashed"></div>

    <div class="continue-btn-wrapper">
      <Button
        type="normal"
        colorType="dark-blue"
        :disabled="!selection"
        @click="onContinue"
      >
        Continue
      </Button>
    </div>
  </Dialog>
</template>

<script>
import Dialog from '@/NewLibrary/Dialog.vue'
import CheckBox from '@/NewLibrary/Checkbox.vue'
import Button from '@/NewLibrary/Button.vue'

export default {
  name: 'ProviderConsentDialogV1',
  components: { Dialog, CheckBox, Button },
  props: { modelValue: { type: Boolean, default: false } },
  emits: ['update:modelValue', 'submit'],
  data() {
    return { selection: null }
  },
  computed: {
    visible: {
      get() { return this.modelValue },
      set(v) { this.$emit('update:modelValue', v) }
    }
  },
  watch: {
    visible(v) { if (v) this.selection = null }
  },
  methods: {
    onSelect(which, status) {
      if (status === 'checked') this.selection = which
      else if (this.selection === which) this.selection = null
    },
    onContinue() {
      if (!this.selection) return
      const accepted = this.selection === 'yes'
      this.visible = false
      this.$emit('submit', accepted)
    }
  }
}
</script>

<style scoped>
.checkbox-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin: 12px 0 20px;
}
.dob-dashed {
  border-bottom: 1px dashed #C8CDD3;
  height: 0;
  margin-top: 6px;
}
.provider-consent-description {
  color: var(--Text-text-primary, #161616);
  text-align: justify;
  font-family: "IBM Plex Sans Hebrew";
  word-break: break-word;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: 0.25px;
}
.continue-btn-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}
</style>